import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalFam = () => {

return(
<div>
    
<Typography variant="h6" >

# CPT2 rs1799821	 A common haplotype of carnitine palmitoyltransferase 1b is associated with the metabolic syndrome (SNPedia)<br /><br /> 

# PCSK9 List of variants reported as benign for familial hyperlipidemia<br /><br /> 

# APOB (with NPC1L1) Novel gene-by-environment interactions: APOB and NPC1L1 variants affect the relationship between dietary and total plasma cholesterol (SNPedia)<br /><br /> 

# WFS1 Adiposity-related heterogeneity in patterns of type 2 diabetes susceptibility observed in genome-wide association data.<br />
# WFS1 role of common and low frequency WFS1 variants in type 2 diabetes risk<br /><br /> 

# PAX4 Polymorphisms rs2233575 and rs712701 in the paired box 4 gene are not associated with type 1 diabetes in children<br /><br /> 

# KCNJ11 Association of KCNJ11 and ABCC8 single-nucleotide polymorphisms with type 2 diabetes mellitus in a Kinh Vietnamese population<br />
# KCNJ11 Genotype C/C -- normal<br /><br /> 

# APOA5 Genetic-epidemiological evidence on genes associated with HDL cholesterol levels: a systematic in-depth review.<br />
# APOA5 Associations of polymorphisms in the apolipoprotein A1/C3/A4/A5 gene cluster with familial combined hyperlipidaemia in Hong Kong Chinese<br />
# APOA5 Haplotype analysis of the apolipoprotein A5 gene in obese pediatric patients
<br /><br /> 
# APOE: Influence of CYP4F2, ApoE, and CYP2A6 gene polymorphisms on the variability of Warfarin dosage requirements and susceptibility to cardiovascular disease in Jordan<br />
# APOE: The ApoE rs7412, rs7259620 and rs405509 loci were associated with cognitive impairment in the elderly population, and there was an interaction between plasma metalloid Cd and the rs7259620 and rs405509 loci that increased the risk of cognitive impairment in the elderly population.


<br /><br /> 

Sources: <br /><br />
https://www.ncbi.nlm.nih.gov/books/NBK343488/   <br />
https://www.ncbi.nlm.nih.gov/gtr/tests/530656/overview/ <br /><br />

 
</Typography>

</div>
)
}